<template>
    <div class="cls-banner" id="cls-banner">
        <div class="cls-banner-home">
            <div class="cls-banner-content">
                <h1 class="cls-banner-title">
                    The <span class="cls-banner-title-special-color">C</span>hinese <span
                        class="cls-banner-title-special-color">L</span>ocal <span class="salmonella"><span
                            class="cls-banner-title-special-color">S</span>almonella</span> <span
                        class="cls-banner-title-special-color">G</span>enome <span
                        class="cls-banner-title-special-color">D</span>ata<span
                        class="cls-banner-title-special-color">B</span>ase version 2 (CLSGDB v2)
                </h1>
                <!-- <p class="cls-baner-text">version 2 (CLSGDB v2)</p> -->
                <div class="cls-banner-input">
                    <el-input placeholder="Search…" v-model="value" class="input-with-select">
                        <el-button slot="append" @click="jumpToDown">
                            <img src="../../images/common/query.png">
                        </el-button>
                    </el-input>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Banner',
    data() {
        return {
            value: '',
        }
    },
    methods: {
        jumpToDown() {
            this.$router.push({
                path: '/download',
            });
        }
    }
}
</script>
<style lang="less">
.cls-banner {
    .cls-banner-content {
        width: 1200px;
        margin: 0 auto;
        padding-top: 170px;
        position: relative;

        .cls-banner-title {
            position: absolute;
            top: 80px;
            left: 0;
            width: 748px;
            height: 108px;
            font-size: 30px;
            // font-family: Arial-BoldMT, Arial;
            font-weight: 700;
            color: #001C66;
            line-height: 54px;

            .cls-banner-title-special-color {
                color: #00BAC8;
            }
        }


        .cls-banner-input {
            width: 720px;
            height: 60px;
            top: 234px;
            position: absolute;

            .el-input {
                height: 100%;

                .el-input__inner {
                    height: 100%;
                    // border-left: none;
                }

                .el-input__inner:focus {
                    border-color: #dcdfe6;
                }

                .el-input__suffix {
                    height: 36px;
                }
            }

            .el-input-group__prepend {
                width: 140px;
                background-color: #fff;
                color: #333;

                .el-select {
                    height: 30px;
                    border-right: 1px solid #dcdfe6;
                }
            }

            .el-input-group__append {
                background: #00BAC8;
                color: #fff;
                cursor: pointer;
                border-color: #00BAC8;
                width: 100px;
                text-align: center;
            }
        }
    }


    .cls-banner-home {
        width: 100%;
        height: 400px;
        background: url("../../images/common/banner.png") no-repeat center;
        background-size: 100% 100%;
    }

}</style>


// WEBPACK FOOTER //
// src/components/common/banner.vue